import script from "./SentencesQueryListWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SentencesQueryListWidget.vue?vue&type=script&setup=true&lang=js"

import "./SentencesQueryListWidget.vue?vue&type=style&index=0&id=d3c06c26&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3c06c26"]])

export default __exports__